interface UtilizationBarProps {
  percent: number;
}

// A small horizontal bar that turns red when a person is over-allocated.
export function UtilizationBar({ percent }: UtilizationBarProps) {
  const clamped = Math.min(percent, 100);
  const over = percent > 100;
  const color = over ? 'bg-red-500' : percent >= 80 ? 'bg-amber-500' : 'bg-green-500';

  return (
    <div>
      <div className="h-2 w-full overflow-hidden rounded bg-gray-100">
        <div className={`h-full ${color}`} style={{ width: `${clamped}%` }} />
      </div>
      <p className={`mt-1 text-xs ${over ? 'text-red-600' : 'text-gray-500'}`}>
        {percent}% utilizat{over ? ' (supra-alocat)' : ''}
      </p>
    </div>
  );
}

export function initials(name: string): string {
  return name
    .split(/\s+/)
    .filter(Boolean)
    .slice(0, 2)
    .map((p) => p[0]?.toUpperCase() ?? '')
    .join('');
}
